module.exports = new __parcel__URL__("Lego.541ea2bd.webp").toString();